/**
 * Small id generator used for logId (one per log event) and requestId
 * (one per API call, shared between its API_REQUEST and matching
 * API_SUCCESS/API_ERROR log so the two can be tied together later).
 *
 * Uses crypto.randomUUID when available (all modern browsers) and falls
 * back to a timestamp+random string otherwise, so this never throws.
 */
const generateId = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // fall through to the fallback below
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export default generateId;
